import { COLORS } from 'styles/constants';

export const BigWhiteLeaf = () => (
  <svg
    width="255"
    height="149"
    viewBox="0 0 255 149"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <filter id="big-white-leaf" x="0" y="0">
        <feGaussianBlur in="SourceGraphic" stdDeviation="1.8" />
      </filter>
    </defs>
    <path
      opacity="0.8"
      filter="url(#big-white-leaf)"
      d="M145.554 16.2087C210.216 36.2871 244.437 111.168 244.437 111.168C244.437 111.168 173.821 153.496 109.159 133.418C44.4969 113.339 10.2756 38.458 10.2756 38.458C10.2756 38.458 80.892 -3.86975 145.554 16.2087Z"
      fill="#F4F5F4"
    />
  </svg>
);

export const BigDarkLeaf = () => (
  <svg
    width="255"
    height="149"
    viewBox="0 0 255 149"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <filter id="big-dark-leaf" x="0" y="0">
        <feGaussianBlur in="SourceGraphic" stdDeviation="0.8" />
      </filter>
    </defs>
    <path
      opacity="0.8"
      filter="url(#big-dark-leaf)"
      d="M145.554 16.2087C210.216 36.2871 244.437 111.168 244.437 111.168C244.437 111.168 173.821 153.496 109.159 133.418C44.4969 113.339 10.2756 38.458 10.2756 38.458C10.2756 38.458 80.892 -3.86975 145.554 16.2087Z"
      fill="#BBC4BA"
    />
  </svg>
);

export const MobileDarkLeaf = () => (
  <svg
    fill="none"
    height="128"
    viewBox="0 0 134 128"
    width="134"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <filter id="mob-dark-leaf" x="0" y="0">
        <feGaussianBlur in="SourceGraphic" stdDeviation="1.2" />
      </filter>
    </defs>
    <path
      opacity="0.8"
      filter="url(#mob-dark-leaf)"
      d="m89.4869 40.2343c25.6511 23.8774 24.1731 67.1597 24.1731 67.1597s-43.0664 4.57-68.7171-19.3075c-25.6508-23.8775-24.1728-67.1601-24.1728-67.1601s43.0661-4.5696 68.7168 19.3079z"
      fill="#bbc4ba"
    />
  </svg>
);

export const MobileWhiteLeaf = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    height="101"
    viewBox="0 0 159 101"
    width="159"
  >
    <defs>
      <filter id="mob-white-leaf" x="0" y="0">
        <feGaussianBlur in="SourceGraphic" stdDeviation="2.8" />
      </filter>
    </defs>
    <path
      opacity="0.8"
      filter="url(#mob-white-leaf)"
      d="m95.2465 13.799c40.5505 12.5914 62.0105 59.5504 62.0105 59.5504s-44.284 26.5442-84.8342 13.9528c-40.5503-12.5914-62.0109-59.5504-62.0109-59.5504s44.2844-26.54426 84.8346-13.9528z"
      fill="#f4f5f4"
    />
  </svg>
);

export const NormalWhite = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" height="93" viewBox="0 0 83 93" width="83">
    <defs>
      <filter id="normal-white" x="0" y="0">
        <feGaussianBlur in="SourceGraphic" stdDeviation="0.8" />
      </filter>
    </defs>
    <path
      opacity="0.8"
      filter="url(#normal-white)"
      d="m24.7945 61.6386c-21.38464-24.3572-21.82442-58.9365-21.82442-58.9365s34.23162 4.91142 55.61622 29.2686c21.3847 24.3572 21.8244 58.9365 21.8244 58.9365s-34.2315-4.9114-55.6162-29.2686z"
      fill="#f4f5f4"
    />
  </svg>
);

export const NormalDark = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" height="70" viewBox="0 0 103 70" width="103">
    <defs>
      <filter id="normal-dark" x="0" y="0">
        <feGaussianBlur in="SourceGraphic" stdDeviation="0.8" />
      </filter>
    </defs>
    <path
      opacity="0.8"
      filter="url(#normal-dark)"
      d="m63.7086 15.9419c27.191 17.6415 36.9964 50.8044 36.9964 50.8044s-34.2802 4.5605-61.4712-13.081c-27.1911-17.6414-36.9964-50.80435-36.9964-50.80435s34.2801-4.56047 61.4712 13.08095z"
      fill={COLORS.primary}
    />
  </svg>
);

export const MobileWhite = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" height="46" viewBox="0 0 46 46" width="46">
    <defs>
      <filter id="mob-white" x="0" y="0">
        <feGaussianBlur in="SourceGraphic" stdDeviation="0.8" />
      </filter>
    </defs>
    <path
      opacity="0.8"
      filter="url(#mob-white)"
      d="m14.9013 14.8155c11.3755-11.37546 28.488-12.70625 28.488-12.70625s-1.3308 17.11255-12.7063 28.48795c-11.3754 11.3755-28.48792 12.7063-28.48792 12.7063s1.33079-17.1125 12.70622-28.488z"
      fill="#f4f5f4"
    />
  </svg>
);

export const MobileDark = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" height="46" viewBox="0 0 48 46" width="48">
    <defs>
      <filter id="mob-dark" x="0" y="0">
        <feGaussianBlur in="SourceGraphic" stdDeviation="0.8" />
      </filter>
    </defs>
    <path
      opacity="0.8"
      filter="url(#mob-dark)"
      d="m31.726 14.5788c11.6504 11.2668 13.2796 28.4819 13.2796 28.4819s-17.26-1.0519-28.9105-12.3186c-11.65052-11.2668-13.27966-28.48193-13.27966-28.48193s17.26006 1.05189 28.91056 12.31863z"
      fill={COLORS.primary}
    />
  </svg>
);
